import React from 'react';
import { Table } from 'react-bootstrap';
import { IntlProvider, FormattedMessage } from 'react-intl';
import './HourlyProductionTable.css';

// Web gösterge panelindeki "Saatlik Üretim Takip" tablosunun aynısı.
// Veri api/Lcd/HourlyProductionTracking uçtan gelir: { lineName, rows[], total }
const HourlyProductionTable = ({ trackingData, lineName }) => {
    const localizationTable = {
        'tr': {
            tableHour: "SAAT",
            tableTarget: "HEDEF",
            tableProduction: "ÜRETİM",
            tableEfficiency: "VERİMLİLİK(%)",
            tableRepair: "TAMİR",
            tableRepairRate: "TAMİR(%)",
            tableTotal: "TOPLAM"
        },
        'tr-TR': {
            tableHour: "SAAT",
            tableTarget: "HEDEF",
            tableProduction: "ÜRETİM",
            tableEfficiency: "VERİMLİLİK(%)",
            tableRepair: "TAMİR",
            tableRepairRate: "TAMİR(%)",
            tableTotal: "TOPLAM"
        },
        'en-US': {
            tableHour: "HOUR",
            tableTarget: "TARGET",
            tableProduction: "PRODUCTION",
            tableEfficiency: "EFFICIENCY(%)",
            tableRepair: "REPAIR",
            tableRepairRate: "REPAIR(%)",
            tableTotal: "TOTAL"
        },
        'en': {
            tableHour: "HOUR",
            tableTarget: "TARGET",
            tableProduction: "PRODUCTION",
            tableEfficiency: "EFFICIENCY(%)",
            tableRepair: "REPAIR",
            tableRepairRate: "REPAIR(%)",
            tableTotal: "TOTAL"
        },
        'ar': {
            tableHour: "ساعة",
            tableTarget: "هدف",
            tableProduction: "إنتاج",
            tableEfficiency: "(%)كفاءة",
            tableRepair: "بصلح",
            tableRepairRate: "(%)بصلح",
            tableTotal: "مجموع"
        }
    };

    const defaultLocale = navigator.language;
    const supportedLocales = ['tr', 'tr-TR', 'en-US', 'ar', 'en'];
    const fallbackLocale = 'en-US';
    const language = supportedLocales.includes(defaultLocale) ? defaultLocale : fallbackLocale;

    // Web'deki formatHourlyNumber ile aynı: binlik ayraçlı, ondalıksız; veri yoksa boş hücre
    const formatNumber = (value) => {
        if (value === null || value === undefined) return '';
        return Number(value).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
    };

    const rows = trackingData?.rows ?? [];
    const total = trackingData?.total;
    const header = trackingData?.lineName || lineName || '';

    return (
        <IntlProvider locale={language} messages={localizationTable[language]}>
            <div className="HourlyProduction">
                <h2 className="table-header">{header}</h2>
                <Table className="table table-bordered">
                    <colgroup>
                        <col style={{ width: '22%' }} />
                        <col style={{ width: '15.6%' }} />
                        <col style={{ width: '15.6%' }} />
                        <col style={{ width: '15.6%' }} />
                        <col style={{ width: '15.6%' }} />
                        <col style={{ width: '15.6%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="col-hour"><FormattedMessage id="tableHour" /></th>
                            <th><FormattedMessage id="tableTarget" /></th>
                            <th><FormattedMessage id="tableProduction" /></th>
                            <th><FormattedMessage id="tableEfficiency" /></th>
                            <th><FormattedMessage id="tableRepair" /></th>
                            <th><FormattedMessage id="tableRepairRate" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            // Mola dilimlerinde sayı sütunları birleşir, yerine molanın adı yazılır
                            row.isBreak ? (
                                <tr key={row.key} className="hourly-break-row">
                                    <td className="col-hour">{row.range}</td>
                                    <td colSpan={5} className="break-name">{row.breakName}</td>
                                </tr>
                            ) : (
                                <tr key={row.key}>
                                    <td className="col-hour">{row.range}</td>
                                    <td>{formatNumber(row.target)}</td>
                                    <td>{formatNumber(row.production)}</td>
                                    <td>{formatNumber(row.efficiency)}</td>
                                    <td>{formatNumber(row.repair)}</td>
                                    <td>{formatNumber(row.repairRate)}</td>
                                </tr>
                            )
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="col-hour"><FormattedMessage id="tableTotal" /></td>
                            <td>{formatNumber(total?.target)}</td>
                            <td>{formatNumber(total?.production)}</td>
                            <td>{formatNumber(total?.efficiency)}</td>
                            <td>{formatNumber(total?.repair)}</td>
                            <td>{formatNumber(total?.repairRate)}</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </IntlProvider>
    );
};

export default HourlyProductionTable;
